module.exports = __webpack_public_path__ + "static/media/farm_pharm_22.c20fb29e.jpg";